import { LoadPastIterationsButton } from '@/components/LoadPastIterationsButton.tsx'
import { DonePanel } from '@/components/panels/DonePanel.tsx'
import { IceboxPanel } from '@/components/panels/IceboxPanel.tsx'
import { Panel } from '@/components/panels/Panel.tsx'
import { RelevantPanel } from '@/components/panels/RelevantPanel.tsx'

type StoryPanelsProps = {
  done?: Story[]
  relevant?: Story[]
  unscheduled?: Story[]
  isShowDone?: boolean
  isShowRelevant?: boolean
  isShowUnscheduled?: boolean
  isShowLoadPastIterationsButton?: boolean
}

export const StoryPanels = ({
  done = [],
  relevant = [],
  unscheduled = [],
  isShowDone,
  isShowRelevant,
  isShowUnscheduled,
  isShowLoadPastIterationsButton = false,
}: StoryPanelsProps) => {
  return (
    <>
      {isShowDone && (
        <Panel title="Done" stories={done}>
          {isShowLoadPastIterationsButton ? <LoadPastIterationsButton /> : null}
        </Panel>
      )}
      {isShowRelevant && <Panel title="Current Iteration/Backlog" stories={relevant} />}
      {isShowUnscheduled && <Panel title="Icebox" stories={unscheduled} />}
    </>
  )
}

type GroupedStoryPanelsProps = {
  filter?: (stories: Story[]) => Story[]
  isShowDone?: boolean
  isShowRelevant?: boolean
  isShowUnscheduled?: boolean
}

export const GroupedStoryPanels = ({
  filter,
  isShowDone,
  isShowRelevant,
  isShowUnscheduled,
}: GroupedStoryPanelsProps) => {
  return (
    <>
      {isShowDone && <DonePanel filter={filter} />}
      {isShowRelevant && <RelevantPanel filter={filter} />}
      {isShowUnscheduled && <IceboxPanel filter={filter} />}
    </>
  )
}
